/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Step_WorkInputs */

const en_coach_step_work = /** @type {(inputs: Coach_Step_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run`)
};

const de_coach_step_work = /** @type {(inputs: Coach_Step_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufen`)
};

/**
* | output |
* | --- |
* | "Run" |
*
* @param {Coach_Step_WorkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_step_work = /** @type {((inputs?: Coach_Step_WorkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Step_WorkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_step_work(inputs)
	return de_coach_step_work(inputs)
});